import { render, staticRenderFns } from "./PapercleanAnagraficaTipiPage.vue?vue&type=template&id=06b8bd16"
import script from "./PapercleanAnagraficaTipiPage.vue?vue&type=script&lang=js"
export * from "./PapercleanAnagraficaTipiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports